export default __webpack_public_path__ + "static/gary-00ab788b5f2462b824719990a39aa00e.png";